import React, { useRef } from 'react'
import { useState } from 'react'
import requestApi from '../../utils/request'
import { useQuery } from '@tanstack/react-query'
// import { useMutation, useQuery, useQueryClient } from 'react-query'

const getVendor = (search) => {
    return requestApi.post(`/vendor/list`, { search }).then((res) => {
        return res.data
    })
}
const AutoSuggestedTextBox = ({ error, setValue, register, value }) => {
    const [input, setInput] = useState('')

    const { data: vendordetail, isLoading } = useQuery({
        queryKey: ['vendor', input],
        queryFn: () => getVendor(input),
        enabled: input.trim().length > 1,
        onSuccess: (data) => {
            setSuggestions(data.data)
        },
        onError: (err) => {}
    })

    const [suggestion, setSuggestions] = useState([])
    const [select, setSelect] = useState('')
    let timmer
    const handleChange = (e) => {
        let value = e.target.value
        // setValue(value)
        setValue({
            sellerId: '',
            fullName: value
        })
        setSuggestions('No Designer Found')
        if (timmer) {
            clearTimeout(timmer)
        }
        timmer = setTimeout(() => {
            setInput(value)
        }, 400)

        // if (value.length >= 1) {
        //     const regex = new RegExp(`${value}`, 'gi')
        //     matches = countries.filter((item) => regex.test(item.game))
        // }
        // setSuggestions(matches)
        // setInput(value)
    }
    const inputref = useRef(null)
    const selectValue = (item) => {
        setSelect(item)
        setSuggestions('')
        // setInput(item.companyName)
        inputref.current.value = item.fullName
    }

    const clearSearch = () => {
        setInput('')
        setSuggestions('')
        setSelect('')
    }

    return (
        <div className="suggestion-wrapper">
            <input
                ref={inputref}
                className="icontrol input-text form-control"
                type="text"
                value={value?.fullName}
                onFocus={() => setSelect('')}
                onChange={handleChange}
            />
            {vendordetail?.data?.length > 0 ? (
                <div className="suggestion-body">
                    {vendordetail?.data?.map((item) => {
                        return (
                            <div
                                className="suggestions-item"
                                key={item.sellerId}
                                onClick={() => {
                                    setValue({
                                        sellerId: item?.sellerId,
                                        fullName: item?.fullName
                                    })
                                    selectValue(item)
                                    setInput('')
                                }}
                            >
                                {item.fullName}
                            </div>
                        )
                    })}
                </div>
            ) : null}
            {error && (
                <span className="error-message" style={{ color: 'red' }}>
                    {error}
                </span>
            )}
        </div>
    )
}

export default AutoSuggestedTextBox
